import { useState } from "react";

import { useTransactions } from "@/api/queries";
import { Pagination } from "@/components/DataTable";
import { EmptyState, ErrorState, TableSkeleton } from "@/components/States";
import { PageHeader } from "@/layout/PageHeader";
import { FillCard, Page } from "@/layout/Page";
import { HistoryTable } from "./HistoryTable";
import { MovementList } from "./MovementList";

const PAGE_SIZE = 50;

/** Movement history (TICKET FE-010): the ledger, readable. */
export function HistoryPage() {
  const [offset, setOffset] = useState(0);
  const { data, isLoading, error, refetch } = useTransactions({ limit: PAGE_SIZE, offset });

  // The ledger endpoint pages without counting: a running shop accumulates a very
  // large history, and COUNT(*) over all of it on every page is wasted work. A
  // full page means there is probably another one.
  const hasMore = data ? data.items.length === data.limit : false;

  return (
    <Page>
      <PageHeader
        title="Historique des mouvements"
        subtitle="Le ledger complet. Une erreur se corrige par une contre-passation, jamais par une suppression."
      />
      <FillCard
        footer={
          data && (
            <Pagination
              offset={data.offset}
              limit={data.limit}
              total={data.offset + data.items.length + (hasMore ? data.limit : 0)}
              onChange={setOffset}
            />
          )
        }
      >
        {isLoading && <TableSkeleton rows={12} columns={6} />}
        {error && <ErrorState error={error} onRetry={() => void refetch()} />}
        {data && data.items.length === 0 && (
          <EmptyState
            title="Aucun mouvement"
            description="Réceptions, sorties, transferts, ajustements et réservations apparaîtront ici."
          />
        )}
        {data && data.items.length > 0 && (
          <>
            <div className="hidden md:block">
              <HistoryTable transactions={data.items} />
            </div>
            <div className="md:hidden">
              <MovementList transactions={data.items} />
            </div>
          </>
        )}
      </FillCard>
    </Page>
  );
}
